import script from "./Referral.vue?vue&type=script&setup=true&lang=js"
export * from "./Referral.vue?vue&type=script&setup=true&lang=js"

import "./Referral.vue?vue&type=style&index=0&id=3b01dde0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b01dde0"]])

export default __exports__